module.exports = __webpack_public_path__ + "8c496c8f91bec5e56cd09c56f9350677.jpg";